<div id="padding">
    <div id="scrollView" [style.height.px]="[getViewHeight()]">
        <pre>{{taskContent}}</pre> 
    </div>
</div>